import { set, toggle } from '@/utils/vuex'
export default {
  setNegocioPropio: set('negocioPropio'),
  setNegocioPropioObj: set('negocioPropioObj'),
  setRestPropio: set('restPropio'),
  setRestPropioObj: set('restPropioObj'),
  setListadoRestaurantes: set('listadoRestaurantes'),
  setListadoRestNegMix: set('listadoRestNegMix'),
  setEsconderLogo: set('esconderLogo')
}